import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nbSpace'
})
export class NbSpacePipe implements PipeTransform {
    transform(value: string): string {
        return value.replace(/ /g, '\u00A0')
    }
}
